import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import noop from 'lodash/noop';
import {
  Radio as BsRadio,
  ToggleButtonGroup,
  ToggleButton as BsToggleButton,
} from 'react-bootstrap';
import SingleChoiceOption from './SingleChoiceOption';
import childrenOfTypes from '../../utils/childrenOfTypes';

import withIdContext from '../../decorators/withIdContext';
import withId from '../../decorators/withId';

export const Radio = withId('Option')(BsRadio);
export const ToggleButton = withId('Option')(BsToggleButton);

export class SingleChoice extends Component {
  RenderToogleWrapper = ({ children }) => {
    const {
      value, className, name, onChange,
    } = this.props;
    return (
      <ToggleButtonGroup
        type="radio"
        name={name}
        value={value}
        className={className}
        onChange={onChange}
        role="radiogroup"
        aria-label={name}
      >
        {children}
      </ToggleButtonGroup>
    );
  }

  renderRadio = ({
    children, optionKey, disabled, className,
  }) => {
    const { value, onChange } = this.props;

    return (
      <Radio
        checked={value === optionKey}
        key={optionKey}
        name={optionKey}
        className={classNames(
          'SingleChoice',
          className,
        )}
        disabled={disabled}
        onChange={() => onChange(optionKey)}
      >
        {children}
      </Radio>
    );
  }

  renderToggle = ({
    children, optionKey, disabled, className,
  }) => (
    <ToggleButton
      key={optionKey}
      id={optionKey}
      name={optionKey}
      value={optionKey}
      disabled={disabled}
      className={classNames(
        'SingleChoice',
        className,
      )}
      role="radio"
    >
      {children}
    </ToggleButton>
  )

  render() {
    const { type } = this.props;
    const options = React.Children.toArray(this.props.children);

    const isRadio = type === 'radio';
    const Wrapper = isRadio ? React.Fragment : this.RenderToogleWrapper;
    const renderOption = isRadio ? this.renderRadio : this.renderToggle;

    return (
      <Wrapper>
        {options.map(({ props }) => renderOption(props))}
      </Wrapper>
    );
  }
}

SingleChoice.Option = SingleChoiceOption;

SingleChoice.propTypes = {
  type: PropTypes.oneOf(['radio', 'toggle']),
  name: PropTypes.string,
  className: PropTypes.string,
  children: childrenOfTypes(SingleChoiceOption).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

SingleChoice.defaultProps = {
  type: 'radio',
  className: null,
  name: null,
  value: null,
  onChange: noop,
};

export default withIdContext('SingleChoice')(SingleChoice);
